import { PaywallAccessType } from '@paywall/types';
import errorLogger from '@paywall/utils/errorLogger';

export default function getAccessHeader(token: string, type: PaywallAccessType) {
  switch (type) {
    case 'Customer':
      return { Authorization: `Bearer ${encodeURIComponent(token)}` };
    case 'Zlick':
      return { 'zlick-token': token };
    case 'ElisaRaamat':
      return { 'X-SIGNATURE': token };
    default:
      errorLogger({ name: 'getAccessHeader()', message: 'Header type is missing' });
  }
}
